import React, { createContext, useContext, useRef, useEffect } from "react";

// Contexto para registrar fontes já carregadas
type FontRegistry = React.MutableRefObject<Set<string>>;
const FontContext = createContext<FontRegistry | null>(null);

export const SmartFontsProvider: React.FC<{ fonts: SmartFontProps[]; children: React.ReactNode }> = ({ fonts, children }) => {
  const loadedFonts = useRef<Set<string>>(new Set());

  useEffect(() => {
    fonts.forEach(font => {
      if (!loadedFonts.current.has(font.id)) {
        // Chame aqui sua lógica de carregamento de fonte (ex: useFont ou loadFont)
        // Exemplo: loadFont(font);
        loadedFonts.current.add(font.id);
      }
    });
  }, [fonts]);

  return (
    <FontContext.Provider value={loadedFonts}>
      {children}
    </FontContext.Provider>
  );
};

export function useFontRegistry() {
  const ctx = useContext(FontContext);
  if (!ctx) throw new Error("useFontRegistry must be used within a SmartFontsProvider");
  return ctx;
}

// Tipagem de exemplo para SmartFontProps
type SmartFontProps = {
  id: string;
  // ...outras propriedades da fonte
};